@if (entityMonitoringTypeUuid$ | async; as entityMonitoringTypeUuid) {
  @if (screeningEntitiesInputParams(); as screeningEntitiesInputParams) {
    @if (person(); as person) {
      @if (isAddedToScreening()) {
        <span class="text-success">
          <i class="fa fa-check mr-1"></i> {{ 'screening.screening_overrides.added_to_screening' | translate }}
        </span>
      } @else {
        <button
          nkButton
          color="secondary"
          size="xs"
          (click)="openAddToScreeningModal(person, screeningEntitiesInputParams, entityMonitoringTypeUuid)">
          {{ 'screening.screening_overrides.add_to_screening' | translate }}
        </button>
      }
    }
  }
}
